var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
/**
 * 8thwall camera component.
 * @deprecated Use the components in https://github.com/WonderlandEngine/wonderland-ar-tracking instead.
 */
class ARCamera8thwall extends Component {
    static TypeName = '8thwall-camera';
    deprecated;
}
__decorate([
    property.bool(true)
], ARCamera8thwall.prototype, "deprecated", void 0);
export { ARCamera8thwall };
//# sourceMappingURL=8thwall-camera.js.map